import PropTypes from "prop-types";
import React, { Component } from "react";

import EditorIndexTitle from "../editor_index_title/EditorIndexTitle";
import i18n from "i18next";
import "./_carouselHeader.scss";

/**
 * Carousel's header, containing the course's title and the expand/collapse buttons
 */
export default class CarouselHeader extends Component {
  /**
   * Constructor
   * @param props
   */
  constructor(props) {
    super(props);
  }

  /**
   * Render React Component
   * @returns {code}
   */
  render() {
    return null;
  }
}

CarouselHeader.propTypes = {
  /**
   * Indicates whether the index has been expanded or not
   */
  carouselShow: PropTypes.bool,
  /**
   * Title of the course as specified on the global settings
   */
  courseTitle: PropTypes.string,
  /**
   * Modifies the course's title
   */
  onTitleChanged: PropTypes.func.isRequired,
  /**
   * Modifies the index's width
   */
  onToggleWidth: PropTypes.func.isRequired,
};
